import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { SqlService } from 'src/app/Database/sql.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-delete-boxes',
  templateUrl: './delete-boxes.component.html',
  styleUrls: ['./delete-boxes.component.css']
})
export class DeleteBoxesComponent implements OnInit {
  BoxNumber = "";

  closeResult = '';
  DisplayErrormessage = "";
  PopupTitle = "";
  ConfirmReset = "";
  SelectedBoxNumbers = [""];
  PossibleBoxNumbers = [""];
  PossibleBox = "";
  constructor(private dbService: SqlService, private router: Router, private modalService: NgbModal) { }

  ngOnInit(): void {
    Swal.fire({
      title: 'Loading Boxes.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });
    this.SelectedBoxNumbers = [];
    this.GetAllBoxNames(" 1=1 ");
  }

  PossibleBoxChanged() {
    this.BoxNumber = this.PossibleBox[0];
  }


  BoxNameChanged() {
    this.GetAllBoxNames(" [Pactel].[dbo].[Boxes].Boxno like '%" + this.BoxNumber + "%' ");
  }

  GetAllBoxNames(condition: string) {
    Swal.fire({
      title: 'Loading Boxes',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.PossibleBoxNumbers.splice(0);


    let formData = new FormData(); // Currently empty
    formData.set("Where", condition);

    (this.dbService.getTopBoxesNames(formData).subscribe((ret: any) => {
      if (ret != "false") {

        (ret as string).split(';').forEach(element => {
          this.PossibleBoxNumbers.push(element);
        });

        Swal.close();
      } else {
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Please check your internet connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    }));
  }

  AddBox(){
    if(this.PossibleBoxNumbers.indexOf(this.BoxNumber) != -1){
      if(this.SelectedBoxNumbers.indexOf(this.BoxNumber) == -1){
        this.SelectedBoxNumbers.push(this.BoxNumber);
      }
    }
  }
  RemoveBox(){
    if(this.SelectedBoxNumbers.indexOf(this.BoxNumber) != -1){
      this.SelectedBoxNumbers = this.SelectedBoxNumbers.filter( x => x !== this.BoxNumber);
    }
  }


  Delete() {

    if (this.SelectedBoxNumbers.length === 0 ) {
      Swal.fire({
        title: "Invalid Data",
        text: "Please select a box to delete",
        icon: "error",
        showConfirmButton: false,
        timer:2000
      });
    } else {
      this.ConfirmReset = "";
      this.PopupTitle = "Warning!"
      this.DisplayErrormessage = "Please type in 'DELETE' below to DELETE the whole the box.";
      let element: HTMLButtonElement = document.getElementById('btnConfirmReset') as HTMLButtonElement;
      element.click();
    }
  }


 
  ActuallyDeleteBox() {
    Swal.fire({
      title: 'Deleting box/s',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    var sqlWhereStatement = "'";
    this.SelectedBoxNumbers.forEach(element => {
      sqlWhereStatement += element + "','";
    });
    sqlWhereStatement = sqlWhereStatement.substring(0 ,  sqlWhereStatement.length-2);

    let formData = new FormData(); 
    formData.set("WhereIn", sqlWhereStatement);
    formData.set("Username", this.dbService.getUsername());

    if(this.dbService.getUsername().length > 5){
      this.dbService.DeleteBox(formData).subscribe((ret: any) => {
        if (!(String(ret).includes("Error"))) {
          
          //Success.
          let tempReults = String(ret);
          let iGrandTotal = tempReults.substring(tempReults.indexOf('.')+1, tempReults.indexOf(';'));
          let iSuccessTotal = tempReults.substring(tempReults.indexOf(';')+1, tempReults.indexOf('-'));
          tempReults = tempReults.substring(tempReults.indexOf('-')+2, tempReults.length);
          console.log(tempReults)

          this.PopupTitle = "Success"
          this.DisplayErrormessage = iSuccessTotal + " out of " + iGrandTotal + " boxes were deleted. Boxes that were not deleted were left in 'Selected Boxes'";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
          Swal.close();
          this.Reset();

          tempReults.split(",").forEach(element => {
            this.SelectedBoxNumbers.push(element.replace(/'/g, ''));
          });
          
        } else {
          console.log(ret)
          this.PopupTitle = "Error"
          this.DisplayErrormessage = "Please check your internet connection and try again";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
          Swal.close();
        }
      });
    }else{
      this.PopupTitle = "Error"
      this.DisplayErrormessage = "Please logout and log back in";
      let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
      element.click();
      Swal.close();
    }

  }

  openConfirmReset(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = 'Closed with: ${result}';
        if (this.ConfirmReset == "DELETE" && result === 'Save click') {
          this.ActuallyDeleteBox();
        }else{
          this.PopupTitle = "Warning"
          this.DisplayErrormessage = "No boxes were deleted.";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
        }
      }, (reason) => {
        this.closeResult =
          'Dismissed ${this.getDismissReason(reason)}';
      });
  }

  Reset() {
    this.BoxNumber = "";
    this.SelectedBoxNumbers = [];
    this.GetAllBoxNames(" 1=1 ");
  }

  open(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult =
          `Dismissed ${this.getDismissReason(reason)}`;
        //let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        //element.click();
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
